<ng-container *ngFor="let task of visit?.tasks">
  <sc-padding>
    <sc-flex>
      <div class="icon-space">
        <sc-icon iconClass="fa-circle-exclamation" *ngIf="!task.optional"></sc-icon>
      </div>
      <sc-content-spacer></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="dd.visitor_role_task.{{task.taskId}}.name"></sc-dictionary-label>
      <sc-content-spacer></sc-content-spacer>
      <div></div>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-icon iconClass="fa-check fa-2x" *ngIf="task.done"></sc-icon>
      <sc-icon iconClass="fa-circle-check fa-2x" *ngIf="task.doneBefore"></sc-icon>
      <sc-button iconClass="fa-check" *ngIf="!task.done && !task.doneBefore" dictionaryKey="tmc-visit.ui.visit.confirm-task" (click)="confirmTask(task)"></sc-button>
    </sc-flex>
  </sc-padding>
  <div class="divider"></div>
</ng-container>
